/**
 * A theme's `states.warning`/`critical`/`overtime` overrides can declare
 * any `color` token they like (`builtin-theme-catalog.ts`'s own Modern
 * palette sets `overtime` to a deliberately dark `#7F1D1D` maroon) — but
 * against that same palette's own dark background, a dark red or dark
 * yellow reads as barely-visible-to-invisible (the exact bug a themed
 * Extended Display hit: an overtime countdown blending into the
 * background). Rather than trust each theme's own fixed hex for these
 * three urgency states, the renderer always substitutes one of these
 * four canonical, contrast-checked variants — a light tint on a dark
 * background, a dark tint on a light background — decided by the
 * theme's own actual background color, not authored per-theme.
 */
const RED_ON_DARK = "#FCA5A5";
const RED_ON_LIGHT = "#B91C1C";
const YELLOW_ON_DARK = "#FDE047";
const YELLOW_ON_LIGHT = "#A16207";
/** Standard YIQ perceived-brightness split (0-255, dark below 128) — good enough for a binary "light or dark background" call, not a full WCAG contrast computation. */
export function isDarkBackground(hex) {
    const match = /^#?([0-9a-fA-F]{6})$/.exec(hex);
    if (!match?.[1])
        return true;
    const value = match[1];
    const r = parseInt(value.slice(0, 2), 16);
    const g = parseInt(value.slice(2, 4), 16);
    const b = parseInt(value.slice(4, 6), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128;
}
/** `"warning"`/`"critical"`/`"overtime"` all read as "red" except warning, which reads as "yellow" — both families get the same light-on-dark/dark-on-light treatment. */
export function zoneColor(zone, backgroundHex) {
    const dark = isDarkBackground(backgroundHex);
    if (zone === "warning")
        return dark ? YELLOW_ON_DARK : YELLOW_ON_LIGHT;
    return dark ? RED_ON_DARK : RED_ON_LIGHT;
}
//# sourceMappingURL=zone-colors.js.map